document.addEventListener("DOMContentLoaded", () => {
  // MENU DRAWER CLOSE JS START
  const closeButton = document.querySelector(".menu-drawer__menu .icon-close");
  const overlay = document.querySelector(".menu-drawer__overlay");

  if (closeButton && overlay) {
    closeButton.addEventListener("click", () => {
      console.log("close clicked===============");
      document.body.classList.remove("overflow-hidden-tablet");
      document.getElementById("Details-menu-drawer-container").removeAttribute("open");
      document.getElementById("Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector("#Details-menu-drawer-container .header__icon").setAttribute("aria-expanded", "false");
    });

    overlay.addEventListener("click", () => {
      console.log("overlay clicked===============");
      document.body.classList.remove("overflow-hidden-tablet");
      document.getElementById("Details-menu-drawer-container").removeAttribute("open");
      document.getElementById("Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector("#Details-menu-drawer-container .header__icon").setAttribute("aria-expanded", "false");
    });
  } else {
    console.error("Elements not found");
  }
  // MENU DRAWER CLOSE JS END

  // EXTRA STRAP MODAL OPEN/CLOSE JS START
  var strap_heading = document.querySelector(".product-block--strap_heading");
  strap_heading?.addEventListener("click", function () {
    document.querySelector(".strap_modal").style.display = "block";
    document.querySelector(".strap_modal").classList.add("active");
    document.querySelector(".strap_modal_overlay").classList.add("active");
    document.querySelector("body").classList.add("overflow-hidden");
    addonStrapFlickitySliderInitialize();
  });

  var strap_modal_close = document.querySelector(".strap_modal .close");
  strap_modal_close?.addEventListener("click", function () {
    document.querySelector(".strap_modal").style.display = "none";
    document.querySelector(".strap_modal").classList.remove("active");
    document.querySelector(".strap_modal_overlay").classList.remove("active");
    document.querySelector("body").classList.remove("overflow-hidden");
    addonStrapFlickitySliderDestroy();
  });

  var strap_modal_overlay = document.querySelector(".strap_modal_overlay");
  strap_modal_overlay?.addEventListener("click", function () {
    document.querySelector(".strap_modal").classList.remove("active");
    document.querySelector(".strap_modal").style.display = "none";
    this.classList.remove("active");
    document.querySelector("body").classList.remove("overflow-hidden");
    addonStrapFlickitySliderDestroy();
  });

  // EXTRA STRAP MODAL OPEN/CLOSE JS END

  // ADDON ITEM FLICKITY SLIDER JS START

  function addonStrapFlickitySliderInitialize() {
    // Initialize Flickity
    var elem = document.querySelector(".product-addon--block");

    var flkty = new Flickity(elem, {
      prevNextButtons: false,
      pageDots: false,
      contain: true,
    });
  }

  function addonStrapFlickitySliderDestroy() {
    var elem = document.querySelector(".product-addon--block");
    var flkty = new Flickity(elem, {
      prevNextButtons: false,
      pageDots: false,
      contain: true,
    });
    flkty.destroy();
  }
  // ADDON ITEM FLICKITY SLIDER JS END

  document.querySelectorAll(".specs-block-title").forEach(function (title) {
    title.addEventListener("click", function () {
      var closeParentItem = title.closest(".specs-blocks-item");
      var parentItems = document.querySelectorAll(".specs-blocks-item");

      if (!closeParentItem.classList.contains("active")) {
        parentItems.forEach(function (item) {
          item.classList.remove("active");
        });
        closeParentItem.classList.add("active");
      } else {
        parentItems.forEach(function (item) {
          item.classList.remove("active");
        });
      }
    });
  });
});

let headerHeading = document.querySelector(".section--specs-block .header-section .heading");
headerHeading?.addEventListener("click", (event) => {
  const specsBlocks = document.querySelector(".section--specs-block .specs-blocks");
  if (specsBlocks) {
    if (specsBlocks.classList.contains("accordion_Active")) {
      event.target.querySelector(".accordion_sign").innerHTML = "+";
    } else {
      event.target.querySelector(".accordion_sign").innerHTML = "-";
    }
    specsBlocks.classList.toggle("accordion_Active");
  }
});

const intervalId = setInterval(() => {
  const reviewDOM = document.querySelector(
    "#yotpo-app .yotpo-main-reviews-widget .yotpo-head .yotpo-headline"
  );
  if (reviewDOM) {
    console.log("Review DOM found, adding click event...");
    const headingElement = document.querySelector("#yotpo-app .yotpo-main-reviews-widget .yotpo-head .yotpo-headline"); // <p class="yotpo-headline">+ REVIEWS</p>
    if (headingElement) {
      const existingText = headingElement.textContent.trim().replace(/^\+/, "").trim();
      const accordionSign = document.createElement("span");
      accordionSign.classList.add("accordion_sign");
      accordionSign.textContent = "+";
      headingElement.textContent = "";
      headingElement.append(accordionSign, " " + existingText);

      headingElement.addEventListener("click", (event) => {
        console.log("Click Event Triggered");
        const specsBlocks = document.querySelector("#yotpo-app .yotpo-main-reviews-widget .yotpo-head + div");
        if (specsBlocks) {
          if (specsBlocks.classList.contains("accordion_Active")) {
            event.target.querySelector(".accordion_sign").innerHTML = "+";
          } else {
            event.target.querySelector(".accordion_sign").innerHTML = "-";
          }
          specsBlocks.classList.toggle("accordion_Active");
        }
      });
    }
    clearInterval(intervalId);
  }
}, 100);

setTimeout(function () {
  clearInterval(intervalId);
}, 10000);

(function landmarkUpcartCart() {
  const LANDMARK_ROLES = [
    "banner",
    "complementary",
    "contentinfo",
    "form",
    "main",
    "navigation",
    "region",
    "search",
  ];

  function cartLabel() {
    return window.accessibilityStrings?.cartLandmark || "Your cart";
  }

  function isLandmark(el) {
    if (!el || el.nodeType !== 1) return false;
    const role = (el.getAttribute("role") || "").toLowerCase();
    if (LANDMARK_ROLES.includes(role)) return true;
    return el.matches("main, nav, aside, [role='main']");
  }

  function ensureRegion(el, labelledBy) {
    if (!el) return;
    if (!isLandmark(el)) {
      el.setAttribute("role", "region");
    }
    if (el.getAttribute("aria-label") || el.getAttribute("aria-labelledby")) return;
    if (labelledBy) {
      if (!labelledBy.id) labelledBy.id = "upcart-header-text";
      el.setAttribute("aria-labelledby", labelledBy.id);
    } else {
      el.setAttribute("aria-label", cartLabel());
    }
  }

  function apply() {
    const host = document.getElementById("upCart");
    const root = host?.shadowRoot;
    const headerText =
      (root && root.querySelector(".upcart-header-text")) ||
      document.querySelector(".upcart-header-text");
    const cart =
      (root && (root.querySelector("#CartPopup") || root.querySelector(".upcart-cart"))) ||
      headerText?.closest(".upcart-cart") ||
      document.querySelector(".upcart-cart");

    if (host) {
      if (!isLandmark(host)) host.setAttribute("role", "region");
      if (!host.getAttribute("aria-label") && !host.getAttribute("aria-labelledby")) {
        host.setAttribute("aria-label", cartLabel());
      }
    }

    if (cart && cart !== host) ensureRegion(cart, headerText);
    if (host?.shadowRoot) observe(host.shadowRoot);

    return Boolean(host || cart);
  }

  function observe(target) {
    if (!target || target.__upcartLandmarkObserved) return;
    target.__upcartLandmarkObserved = true;
    new MutationObserver(apply).observe(target, { childList: true, subtree: true });
  }

  function start() {
    apply();
    observe(document.documentElement);
    const host = document.getElementById("upCart");
    if (host?.shadowRoot) observe(host.shadowRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

(function labelOrphanBodyInputs() {
  function accessibleName(el) {
    if (el.getAttribute("aria-label") || el.getAttribute("aria-labelledby") || el.title) return true;
    if (el.labels && el.labels.length) return true;
    if (el.id) {
      try {
        if (document.querySelector('label[for="' + CSS.escape(el.id) + '"]')) return true;
      } catch (e) {
        if (document.querySelector('label[for="' + el.id + '"]')) return true;
      }
    }
    return false;
  }

  function isSkippableType(el) {
    const type = (el.type || "text").toLowerCase();
    return type === "hidden" || type === "submit" || type === "button" || type === "reset" || type === "image";
  }

  function isDummyHiddenInput(el) {
    if (el.parentElement !== document.body) return false;
    const cs = getComputedStyle(el);
    const inline = el.getAttribute("style") || "";
    return (
      (cs.opacity === "0" || inline.includes("opacity: 0")) &&
      (cs.position === "absolute" || inline.includes("position: absolute")) &&
      (cs.width === "0px" || inline.includes("width: 0"))
    );
  }

  function fix(el) {
    if (!el || el.tagName !== "INPUT") return;
    if (el.parentElement !== document.body) return;
    if (isSkippableType(el)) return;

    if (!accessibleName(el)) {
      el.setAttribute("aria-label", window.accessibilityStrings?.hiddenInputLabel || "Hidden form field");
    }

    if (isDummyHiddenInput(el)) {
      el.setAttribute("aria-hidden", "true");
      el.setAttribute("tabindex", "-1");
      el.setAttribute("inert", "");
    }
  }

  function scan() {
    document.querySelectorAll("body > input").forEach(fix);
  }

  function start() {
    scan();
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1 && node.tagName === "INPUT") fix(node);
        }
      }
    }).observe(document.body, { childList: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

(function landmarkFreeShippingBanner() {
  const LANDMARK_ROLES = [
    "banner",
    "complementary",
    "contentinfo",
    "form",
    "main",
    "navigation",
    "region",
    "search",
  ];

  function bannerLabel() {
    return window.accessibilityStrings?.freeShippingLandmark || "Free shipping";
  }

  function isLandmark(el) {
    if (!el || el.nodeType !== 1) return false;
    const role = (el.getAttribute("role") || "").toLowerCase();
    if (LANDMARK_ROLES.includes(role)) return true;
    return el.matches("main, nav, aside, header, footer");
  }

  function ensureRegion(el) {
    if (!el) return;
    if (!isLandmark(el)) el.setAttribute("role", "region");
    if (!el.getAttribute("aria-label") && !el.getAttribute("aria-labelledby")) {
      el.setAttribute("aria-label", bannerLabel());
    }
  }

  function apply() {
    const banner = document.getElementById("FreeShippingBanner");
    const containers = document.querySelectorAll(".ge-free-shipping-container");
    const targets = new Set();

    if (banner) targets.add(banner.closest(".ge-free-shipping-container") || banner);
    containers.forEach((el) => targets.add(el));
    targets.forEach(ensureRegion);
    return targets.size > 0;
  }

  function start() {
    apply();
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

(function hideFocusInAriaHiddenProductSlides() {
  const SLIDE_SELECTOR =
    ".section--featured-products-slider__item, .section--collection-products-slider__item";
  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const PREV_TABINDEX = "data-a11y-prev-tabindex";

  function hideFocusable(el) {
    el.setAttribute("inert", "");
    el.querySelectorAll(FOCUSABLE_SELECTOR).forEach((node) => {
      if (!node.hasAttribute(PREV_TABINDEX)) {
        node.setAttribute(PREV_TABINDEX, node.hasAttribute("tabindex") ? node.getAttribute("tabindex") : "");
      }
      node.setAttribute("tabindex", "-1");
    });
  }

  function restoreFocusable(el) {
    el.removeAttribute("inert");
    el.querySelectorAll("[" + PREV_TABINDEX + "]").forEach((node) => {
      const prev = node.getAttribute(PREV_TABINDEX);
      if (prev === "") node.removeAttribute("tabindex");
      else node.setAttribute("tabindex", prev);
      node.removeAttribute(PREV_TABINDEX);
    });
  }

  function sync(el) {
    if (!el || el.nodeType !== 1 || !el.matches(SLIDE_SELECTOR)) return;
    if (el.getAttribute("aria-hidden") === "true") hideFocusable(el);
    else restoreFocusable(el);
  }

  function scan(root) {
    const scope = root && root.nodeType === 1 ? root : document;
    if (scope.matches?.(SLIDE_SELECTOR)) sync(scope);
    scope.querySelectorAll?.(SLIDE_SELECTOR).forEach(sync);
  }

  function start() {
    scan(document);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes") {
          sync(mutation.target);
          continue;
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      }
    }).observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

(function positionHeaderFromAnnouncementBar() {
  function elementHeight(el) {
    if (!el) return 0;
    return Math.round(el.getBoundingClientRect().height);
  }

  function headerOffsetHeight() {
    const announcementHeight = elementHeight(document.querySelector(".announcement-bar-section"));
    if (announcementHeight > 0) return announcementHeight;
    return elementHeight(document.querySelector(".ge-free-shipping-container"));
  }

  function updateHeaderTop() {
    const sectionHeader = document.querySelector(".section-header");
    if (!sectionHeader) return;

    const freeShipping = document.querySelector(".ge-free-shipping-container");
    if (freeShipping && sectionHeader.classList.contains("shopify-section-header-sticky")) {
      sectionHeader.style.setProperty("top", "0px", "important");
      return;
    }

    const height = headerOffsetHeight();
    if (height > 0) sectionHeader.style.setProperty("top", height + "px", "important");
    else sectionHeader.style.removeProperty("top");
  }

  let observedFreeShipping = false;

  function observe(el) {
    if (!el || typeof ResizeObserver === "undefined") return;
    new ResizeObserver(updateHeaderTop).observe(el);
  }

  function start() {
    updateHeaderTop();
    window.addEventListener("resize", updateHeaderTop);
    document.addEventListener("shopify:section:load", updateHeaderTop);
    document.addEventListener("shopify:section:reorder", updateHeaderTop);

    const sectionHeader = document.querySelector(".section-header");
    if (sectionHeader) {
      new MutationObserver(updateHeaderTop).observe(sectionHeader, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    observe(document.querySelector(".announcement-bar-section"));

    const freeShipping = document.querySelector(".ge-free-shipping-container");
    if (freeShipping) {
      observe(freeShipping);
      observedFreeShipping = true;
    } else {
      const injectionObserver = new MutationObserver(() => {
        if (observedFreeShipping) return;
        const injected = document.querySelector(".ge-free-shipping-container");
        if (!injected) return;
        observe(injected);
        observedFreeShipping = true;
        updateHeaderTop();
        injectionObserver.disconnect();
      });
      injectionObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

